export function getProjectBridgeListScrollKey({ pathname, search, sortField, sortDirection }) {
    return `project-bridge-list:${pathname || ""}:${search || ""}:${sortField || "code"}:${sortDirection || "asc"}`
}

export function getProjectBridgeSelectableScheduleIds(items = []) {
    const seen = new Set()
    const scheduleIds = []

    for (const item of items) {
        const scheduleId = item?.scheduleId
        if (!scheduleId || seen.has(scheduleId)) continue

        seen.add(scheduleId)
        scheduleIds.push(scheduleId)
    }

    return scheduleIds
}

export function getProjectBridgeSelectedScheduleIds(selectedScheduleIdsById = {}, items = []) {
    return getProjectBridgeSelectableScheduleIds(items).filter(function isSelected(scheduleId) {
        return Boolean(selectedScheduleIdsById[scheduleId])
    })
}

export function getProjectBridgeCreateWorkPackageLabel(selectedCount) {
    if (!selectedCount) return "Create Work Package"
    return `Create Work Package (${selectedCount})`
}
